module.exports = __webpack_public_path__ + "static/media/gp6.3fc7ffe4.webp";